const findSlugColor = (colors, color) => {
  let slug = '';
  for (let i = 0; colors?.length >= i; i++) {
    if (
      colors[i]?.name?.toLowerCase() === color.toLowerCase() ||
      colors[i]?.slug?.toLowerCase() === color.toLowerCase()
    ) {
      slug = colors[i]?.slug;

      break;
    }
  }
  return slug;
};

export default findSlugColor;
